import { createSelector } from '@reduxjs/toolkit';
import { selectPriceTypeValue } from './selectPriceTypeValue';
import { EPriceType } from '../../../../packages/JsonQuery';
import { selectPriceTypeLabel } from './selectPriceTypeLabel';

const PRICE_TYPE_OPTIONS = [
  { label: 'за всё', value: EPriceType.Total },
  { label: 'за м\u00B2', value: EPriceType.SM },
];

export const selectPriceTypeFilter = createSelector([selectPriceTypeLabel, selectPriceTypeValue], (label, value) => ({
  label,
  value: [value],
  options: PRICE_TYPE_OPTIONS,
}));
